import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  countryCodeService,
  type CreateCountryCodeRequest,
  type UpdateCountryCodeRequest,
  type CountryCodeListFilters,
} from '../../services/api/countryCodeService';

// --- Country Code Thunks ---

export const fetchCountryCodes = createAsyncThunk(
  'countryCode/fetchCountryCodes',
  async (filters: CountryCodeListFilters, { rejectWithValue }) => {
    try {
      return await countryCodeService.getCountryCodes(filters);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to fetch country codes');
    }
  }
);

export const fetchActiveCountryCodes = createAsyncThunk(
  'countryCode/fetchActiveCountryCodes',
  async (_, { rejectWithValue }) => {
    try {
      return await countryCodeService.getActiveCountryCodes();
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to fetch active country codes');
    }
  }
);

export const createCountryCode = createAsyncThunk(
  'countryCode/createCountryCode',
  async (request: CreateCountryCodeRequest, { rejectWithValue }) => {
    try {
      return await countryCodeService.createCountryCode(request);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to create country code');
    }
  }
);

export const updateCountryCode = createAsyncThunk(
  'countryCode/updateCountryCode',
  async ({ id, request }: { id: number; request: UpdateCountryCodeRequest }, { rejectWithValue }) => {
    try {
      return await countryCodeService.updateCountryCode(id, request);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to update country code');
    }
  }
);

export const deleteCountryCode = createAsyncThunk(
  'countryCode/deleteCountryCode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await countryCodeService.deleteCountryCode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to delete country code');
    }
  }
);

export const activateCountryCode = createAsyncThunk(
  'countryCode/activateCountryCode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await countryCodeService.activateCountryCode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to activate country code');
    }
  }
);

export const deactivateCountryCode = createAsyncThunk(
  'countryCode/deactivateCountryCode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await countryCodeService.deactivateCountryCode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to deactivate country code');
    }
  }
);
